// // "use client";
// import React, { useState } from "react";
// // import img from "next/img";
// import background from "../public/bg-curved.svg";
// import back from "../public/bg-semicircle.svg";
// import iconPU from "../public/pu-icon.svg";
// import iconUser from "../public/icon-user.svg";
// import iconPassword from "../public/icon-password.svg";
// import { loadavg } from "os";

// export default function LoginForm() {
//   const [loading, setloading] = useState(false);
//   const [loginData, setLoginData] = useState({
//     username: "",
//     password: "",
//   });

//   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const { name, value } = e.target;
//     setLoginData({
//       ...loginData,
//       [name]: value,
//     });
//   };

//   const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
//     e.preventDefault();
//     console.log(loginData);
//   };

//   return (

//     <main className="flex  flex-col items-center w-full justify-between">
//       <div className="relative hidden md:block w-full">
//         <div className="absolute -z-10 flex w-full h-fit justify-end">
//           <img
//             src={background}
//             alt="bg1"
//             className="w-3/5"
//             width={500}
//             height={100}
//           />
//         </div>
//       </div>
//       <section className="flex flex-col items-center w-full md:w-1/4 justify-center mt-36 lg:mt-64">
//         <div className="relative">
//           <div className="flex items-center">
//             <div className="relative">
//               <img src={iconPU} alt="bg1" width={50} height={50} />
//             </div>
//             <article className="relative mt-8 -ml-4">
//               <p className="text-[#000413] font-inter text-2xl font-semibold leading-normal">
//                 PURE{" "}
//                 <span className="bg-[#000413] text-[#FFC727] font-normal rounded-sm px-2">
//                   WORKER
//                 </span>
//               </p>
//             </article>

// <!--     <>
//       <main className="flex  flex-col items-center w-full justify-between">
//         <div className="relative w-full">
//           <div className="absolute -z-10 flex w-full h-fit justify-end">
//             <img
//               src={background}
//               alt="bg1"
//               className="w-3/5"
//               width={500}
//               height={100}
//             /> -->

//           </div>
//         </div>
//         <section className="flex flex-col items-center w-1/4 justify-center mt-64">
//           <div className="relative">
//             <div className="flex items-center">
//               <div className="relative">
//                 <img src={iconPU} alt="bg1" width={50} height={50} />
//               </div>
//               <article className="relative mt-8 -ml-4">
//                 <p className="text-[#000413] font-inter text-2xl font-semibold leading-normal">
//                   PURE{" "}
//                   <span className="bg-[#000413] text-[#FFC727] font-normal rounded-sm px-2">
//                     WORKER
//                   </span>
//                 </p>
//               </article>
//             </div>
//           </div>
//           <div className="mt-20 flex flex-col items-center">
//             <form
//               action=""
//               onChange={handleSubmit}
//               className="space-y-5 relative z-30"
//             >
//               <div className="relative">
//                 <div className="absolute top-0 left-0 flex items-center h-full pl-3">
//                   <img src={iconUser} alt="User" />
//                 </div>
//                 <input
//                   type="text"
//                   id="username"
//                   name="username"
//                   className="focus:outline-none  px-14 w-full bg-[#fff] border border-[#000] rounded-md py-2 text-[#000]  font-montserrat text-xs font-light leading-5 tracking-wide uppercase "
//                   // required
//                   placeholder="Username"
//                   onChange={handleChange}
//                 />
//               </div>
//               <div className="relative">
//                 <div className="absolute top-0 left-0 flex items-center h-full pl-3">
//                   <img src={iconPassword} alt="Password" />
//                 </div>
//                 <input
//                   type="password"
//                   id="PassWord"
//                   name="PassWord"
//                   className="focus:outline-none  px-14 w-full bg-[#fff] border border-[#000]  rounded-md py-2 text-[#000]  font-montserrat text-xs font-light leading-5 tracking-wide uppercase "
//                   // required
//                   placeholder="Password"
//                 />
//               </div>
//               <div className="">
//                 <button
//                   type="submit"
//                   className="w-full bg-[#000] py-2 text-[#FFCD1E] rounded-md mt-8 text-center font-montserrat text-base font-semibold leading-5 tracking-wide uppercase cursor-pointer"
//                 >
//                   Login
//                 </button>
//               </div>
//             </form>
//             <div className="flex justify-between w-full mt-2">
//               <div></div>
//               <div className="text-right cursor-pointer">
//                 <p className="text-[#000] font-montserrat text-base font-medium leading-normal ">
//                   Forgot Password?
//                 </p>
//               </div>
//             </div>
//           </div>
//         </section>
//         <div className="absolute left-0 w-full h-fit  mt-64">
//           <div className="relative w-full h-fit" style={{ marginLeft: "-25%" }}>
//             <img
//               src={back}
//               alt="bg1"
//               className="w-1/2"
//               width={500}
//               height={100}
//               style={{
//                 clipPath: "inset(0% 0% 0% 45%)",
//               }}
//             />
//           </div>
//         </div>

//       </section>
//       <div className="absolute left-0 w-full h-fit  mt-64 hidden md:block">
//         <div className="relative w-full h-fit" style={{ marginLeft: "-25%" }}>
//           <img
//             src={back}
//             alt="bg1"
//             className="w-1/2"
//             width={500}
//             height={100}
//             style={{
//               clipPath: "inset(0% 0% 0% 45%)",
//             }}
//           />
//         </div>
//       </div>

//       </main>

// //     </>
//   );
// }

// "use client";
// import React, { useEffect, useState } from "react";
// import background from "../public/bg-curved.svg";
// import back from "../public/bg-semicircle.svg";
// import iconPU from "../public/pu-icon.svg";
// import iconUser from "../public/icon-user.svg";
// import iconPassword from "../public/icon-password.svg";
// import { loadavg } from "os";
// import { useAppDispatch, useAppSelector } from "../utils/redux/hooks";
// import { addisLoading, loggedIn } from "../utils/redux/mainSlice";
// import { signIn, verifyMfaCode } from "../utils/apis/func";
// import { useNavigate } from "react-router-dom";
// import { RootState } from "../utils/redux/store";
// import { toast } from "react-toastify";
// import Loader from "../components/Loader";

// export default function LoginForm() {
//   const [loading, setloading] = useState(false);
//   const [loginData, setLoginData] = useState({
//     email: "",
//     password: "",
//   });

//   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const { name, value } = e.target;
//     setLoginData({
//       ...loginData,
//       [name]: value,
//     });
//   };

//   const [isLoading, setisLoading] = useState(false);

//   const navigate = useNavigate();
//   const dispatch = useAppDispatch();
//   const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
//     e.preventDefault();
//     console.log(loginData);
//     setisLoading(true);
//     // dispatch(addisLoading(true));
//     const res: any = await signIn(loginData);
//     dispatch(addisLoading(false));
//     setisLoading(false);
//   };
//   const _loggedIn = useAppSelector((store: RootState) => store.user.isLoggedIn);

//   useEffect(() => {
//     if (_loggedIn && _loggedIn.token) {
//       navigate("/dashboard");
//     }
//   }, [_loggedIn, navigate]);

//   return (
//     <main className="flex lg:h-[100vh] flex-col items-center w-[100vw] justify-between">
//       <section className="flex flex-col items-center w-full md:w-1/4 lg:w-1/2  lg:mx-auto sm:mx-auto justify-center mt-36 lg:mt-50">
//         <div className="relative">
//           <div className="flex items-center">
//             <div className="relative">
//               <img src={iconPU} alt="bg1" width={50} height={50} />
//             </div>
//             <article className="relative mt-8 -ml-4">
//               <p className="text-[#000413] font-inter text-2xl font-semibold leading-normal">
//                 PURE{" "}
//                 <span className="bg-[#000413] text-[#FFC727] font-normal rounded-sm px-2">
//                   WORKER
//                 </span>
//               </p>
//             </article>
//           </div>
//         </div>
//         <div className="mt-20 flex flex-col items-center">
//           <form
//             action=""
//             // onChange={handleSubmit}
//             onSubmit={handleSubmit}
//             className="space-y-5 relative z-30"
//           >
//             <div className="relative">
//               <div className="absolute top-0 left-0 flex items-center h-full pl-3">
//                 <img src={iconUser} alt="User" />
//               </div>
//               <input
//                 type="text"
//                 id="email"
//                 name="email"
//                 className="focus:outline-none  px-14 w-full bg-[#fff] border border-[#000] rounded-md py-2 text-[#000]  font-montserrat text-xs font-light leading-5 tracking-wide uppercase "
//                 // required
//                 placeholder="Email"
//                 onChange={handleChange}
//               />
//             </div>
//             <div className="relative">
//               <div className="absolute top-0 left-0 flex items-center h-full pl-3">
//                 <img src={iconPassword} alt="Password" />
//               </div>
//               <input
//                 type="password"
//                 id="passWord"
//                 name="password"
//                 className="focus:outline-none  px-14 w-full bg-[#fff] border border-[#000]  rounded-md py-2 text-[#000]  font-montserrat text-xs font-light leading-5 tracking-wide uppercase "
//                 // required
//                 placeholder="Password"
//                 onChange={handleChange}
//               />
//             </div>

//             {isLoading ? (
//               <div className="text-center">
//                 <div role="status">
//                   <svg
//                     aria-hidden="true"
//                     className="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
//                     viewBox="0 0 100 101"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
//                       fill="currentColor"
//                     />
//                     <path
//                       d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
//                       fill="currentFill"
//                     />
//                   </svg>
//                   <span className="sr-only">Loading...</span>
//                 </div>
//               </div>
//             ) : (
//               <div className="">
//                 <button
//                   type="submit"
//                   className="w-full bg-[#000] py-2 text-[#FFCD1E] rounded-md mt-8 text-center font-montserrat text-base font-semibold leading-5 tracking-wide uppercase cursor-pointer"
//                 >
//                   Login
//                 </button>
//               </div>
//             )}
//           </form>
//           <div className="flex justify-between w-full mt-2">
//             <div></div>
//             <div className="text-right cursor-pointer">
//               <p className="text-[#000] font-montserrat text-base font-medium leading-normal ">
//                 Forgot Password?
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>
//       <div className="absolute left-0 w-full h-fit  mt-64 hidden md:block">
//         <div className="relative w-full h-fit" style={{ marginLeft: "-25%" }}>
//           <img
//             src={back}
//             alt="bg1"
//             className="w-1/2"
//             width={500}
//             height={100}
//             style={{
//               clipPath: "inset(0% 0% 0% 45%)",
//             }}
//           />
//         </div>
//       </div>

//       {loading && <Loader />}
//     </main>
//   );
// }


import { useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { signIn, verifyMfaCode } from "../utils/apis/func";
import { useAppDispatch, useAppSelector } from "../utils/redux/hooks";
import { loggedIn } from "../utils/redux/mainSlice";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import {adminReturnTo} from './config/adminReturnTo';
import { toast } from "react-toastify";
import Loader from "../components/Loader";
import iconPU from "../public/pu-icon.svg";
import iconUser from "../public/icon-user.svg";
import iconPassword from "../public/icon-password.svg";

const validationSchema = Yup.object({
  email: Yup.string().email("Invalid email address").required("Required"),
  password: Yup.string().required("Required"),
});



const initialValues = {
  email: "",
  password: "",
};

const LoginForm = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = adminReturnTo((location.state as any)?.from);

  const [loading, setloading] = useState(false);
  // A second factor is pending: the password was right, but it bought a five
  // minute challenge cookie rather than a session. Kept in component state only
  // — the challenge itself is an httpOnly cookie this code cannot read.
  const [mfaPending, setMfaPending] = useState(false);
  const [mfaCode, setMfaCode] = useState("");
  // const fetchData = async () => {
  //   // console.log('started', d);
  //   const res: any = await getUser("");
  //   console.log(res);
  //   if (res?.status === 200 || res?.status === 201) {
  //     dispatch(adduserData(res?.data?.user));
  //   }
  // };
  // fetchData();

  // The second step. The challenge rides as an httpOnly cookie set by the login
  // response, so nothing is passed here but the six digits.
  const handleMfaSubmit = async (e: any) => {
    e?.preventDefault?.();
    const code = mfaCode.replace(/\s+/g, "");
    if (code.length < 6) {
      toast("Enter the 6 digit code from your authenticator app", {
        position: "top-right", autoClose: 5000, theme: "light", type: "error",
      });
      return;
    }
    setloading(true);
    const res: any = await verifyMfaCode(code);
    setloading(false);
    if (res?.status === 200) {
      dispatch(loggedIn({ type: res?.data?.user?.accountType?.toUpperCase() }));
      localStorage.setItem("Role", res?.data?.user?.accountType);
      // Only now is there a session, so only now is the marker true.
      localStorage.setItem("pw_admin_session", "1");
      toast("Login Successfully", {
        position: "top-right", autoClose: 5000, theme: "light",
      });
      navigate(returnTo, {replace: true});
      return;
    }
    setMfaCode("");
    toast(`Error: ${res?.error?.message || "That code is not valid"}`, {
      position: "top-right", autoClose: 5000, theme: "light", type: "error",
    });
  };

  const handleSubmit = async (values:any, { setSubmitting }:any) => {
    try {
      if (!values?.password) {
        toast(`Error: Password is required`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          type: "error",
        });
      }
      if (!values?.email) {
        toast(`Error: Email is required`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          type: "error",
        });
      }
      setloading(true);
      const res: any = await signIn(values);
      // Checked BEFORE the success branch: this is a 200, and the branch below
      // reads res.data.user, which a challenge response deliberately has none of.
      if (res?.data?.status === "mfa_required") {
        setloading(false);
        setMfaPending(true);
        return;
      }
      if (res?.status === 200 || res?.status === 201) {
        dispatch(
          loggedIn({
            // No token: the API sets an httpOnly cookie instead.
            type: res?.data?.user.accountType?.toUpperCase(),
          })
        );
        toast("Login Successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate(returnTo, {replace: true});
      }else{
        console.log(res?.error);
        
      // if (res?.status === 400 || res?.status === 404 || res?.status === 500 || res?.status === 401) {
        toast(`Error: ${ res?.error?.message || res?.error }`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          type: "error",
        });
      }
    } catch (error) {
      // Handle login error
      console.error("Login failed:", error);
      toast(`Error: ${error}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        // type: "error",
      });
    } finally {
      setSubmitting(false);
      setloading(false)
    }
  };

  const _loggedIn = useAppSelector((store) => store.user.isLoggedIn);

  /* Same rule as the route guard (pages/config/Protected.tsx): the session is
     an httpOnly cookie this code cannot read, so check the UI marker. Gating on
     `_loggedIn.token` here meant an admin who was already signed in and opened
     /login was shown the form again, because the API stopped returning a token
     when auth moved to the cookie. */
  const hasSession =
    Boolean(_loggedIn?.authenticated) ||
    (typeof window !== "undefined" &&
      window.localStorage.getItem("pw_admin_session") === "1");

  if (hasSession) {
    return <Navigate to={returnTo} replace />;
  }

  return (
    <main className="flex lg:h-[100vh] flex-col items-center w-[100vw] justify-between">
      <section className="flex flex-col items-center w-full md:w-1/4 lg:w-1/2  lg:mx-auto sm:mx-auto justify-center mt-36 lg:mt-50">
        <div className="relative">
          <div className="flex items-center">
            <div className="relative">
              <img src={iconPU} alt="bg1" width={50} height={50} />
            </div>
            <article className="relative mt-8 -ml-4">
              <p className="text-[#000413] font-inter text-2xl font-semibold leading-normal">
                PURE{" "}
                <span className="bg-[#000413] text-[#FFC727] font-normal rounded-sm px-2">
                  WORKER
                </span>
              </p>
            </article>
          </div>
        </div>
        <div className="mt-20 flex flex-col items-center">
            {mfaPending ? (
              /* Second step. The password form is REPLACED rather than hidden, so
                 it cannot be resubmitted while a challenge is open. */
              <form onSubmit={handleMfaSubmit} className="space-y-5 relative z-30">
                <p className="text-[#000413] font-inter text-base text-center max-w-[300px]">
                  Enter the 6 digit code from your authenticator app.
                </p>
                <input
                  type="text"
                  inputMode="numeric"
                  autoComplete="one-time-code"
                  autoFocus
                  maxLength={11}
                  aria-label="Authentication code"
                  value={mfaCode}
                  onChange={(e) => setMfaCode(e.target.value)}
                  placeholder="123456"
                  className="w-[300px] py-3 px-4 text-center tracking-[0.3em] text-lg bg-[#EFF6FF] rounded-md outline-none"
                />
                <button
                  type="submit"
                  disabled={loading}
                  className="w-[300px] bg-[#000413] text-[#FFC727] font-inter font-semibold py-3 rounded-md disabled:opacity-60"
                >
                  {loading ? "CHECKING..." : "VERIFY"}
                </button>
                <p className="text-center text-xs text-[#8E8E93] max-w-[300px]">
                  Lost your phone? Enter one of your backup codes instead.
                </p>
                <p
                  onClick={() => { setMfaPending(false); setMfaCode(""); }}
                  className="text-center text-sm underline cursor-pointer text-[#000413]"
                >
                  Back to login
                </p>
              </form>
            ) : (
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            <Form className="space-y-5 relative z-30">
              <div className="relative">
                <div className="absolute top-0 left-0 flex items-center h-full pl-3">
                  <img src={iconUser} alt="User" />
                </div>
                <Field
                  type="text"
                  id="email"
                  name="email"
                  className="focus:outline-none  px-14 w-full bg-[#fff] border border-[#000] rounded-md py-2 text-[#000]  font-montserrat text-xs font-light leading-5 tracking-wide uppercase "
                  placeholder="Email"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-red-500 text-xs font-light"
                />
              </div>
              <div className="relative">
                <div className="absolute top-0 left-0 flex items-center h-full pl-3">
                  <img src={iconPassword} alt="Password" />
                </div>
                <Field
                  type="password"
                  id="password"
                  name="password"
                  className="focus:outline-none  px-14 w-full bg-[#fff] border border-[#000]  rounded-md py-2 text-[#000]  font-montserrat text-xs font-light leading-5 tracking-wide uppercase "
                  placeholder="Password"
                />
                <ErrorMessage
                  name="password"
                  component="div"
                  className="text-red-500 text-xs font-light"
                />
              </div>
              <div className="">
                <button
                  type="submit"
                  className="w-full bg-[#000] py-2 text-[#FFCD1E] rounded-md mt-8 text-center font-montserrat text-base font-semibold leading-5 tracking-wide uppercase cursor-pointer"
                >
                  Login
                </button>
              </div>
            </Form>
          </Formik>
            )}
          {/* <div className="flex justify-between w-full mt-2">
            <div></div>
            <div className="text-right cursor-pointer">
              <p className="text-[#000] font-montserrat text-base font-medium leading-normal ">
                Forgot Password?
              </p>
            </div>
          </div> */}
        </div>
      </section>
      <div className="absolute left-0 w-full h-fit  mt-64 hidden md:block">
        <div className="relative w-full h-fit" style={{ marginLeft: "-25%" }}>
          {/* Add your SVG or Image component here */}
        </div>
      </div>

      {loading && <Loader />}
    </main>
  );
};

export default LoginForm;

